import { render, staticRenderFns } from "./Inscricoes.vue?vue&type=template&id=b70c6bb0&scoped=true"
import script from "./Inscricoes.vue?vue&type=script&lang=js"
export * from "./Inscricoes.vue?vue&type=script&lang=js"
import style0 from "./Inscricoes.vue?vue&type=style&index=0&id=b70c6bb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70c6bb0",
  null
  
)

export default component.exports